export default "__VITE_ASSET__e8382dbc__"